import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "assets/svg/lisapropFavicon.svg";
import PrivateRoute from "context/PrivateRoute";
import VisitorRouter from "context/VisitorRouter";
import AdminRouter from "context/AdminRouter";

const LandingPage = React.lazy(() => import("screens/LandingPage"));
const About = React.lazy(() => import("screens/About"));
const PrivacyPolicy = React.lazy(() => import("screens/PrivacyPolicy"));
const Terms = React.lazy(() => import("screens/Terms"));
const ContactUs = React.lazy(() => import("screens/ContactUs"));
const Solutions = React.lazy(() => import("screens/Solutions"));
const Login = React.lazy(() => import("screens/onboarding/Login"));
const Signup = React.lazy(() => import("screens/onboarding/SignUp"));
const ForogotPassword = React.lazy(
  () => import("screens/onboarding/ForogtPassword")
);
const Dashboard = React.lazy(() => import("screens/Dashboard"));
const Projects = React.lazy(() => import("screens/Projects"));
const Offers = React.lazy(() => import("screens/Offers"));
// const Settings = React.lazy(() => import("screens/Settings"));
const Profile = React.lazy(() => import("screens/Profile"));
const ProjectDetails = React.lazy(() => import("screens/ProjectDetails"));
const TrackProjectDetails = React.lazy(
  () => import("screens/TrackProjectDetails")
);
const ProposalDetails = React.lazy(() => import("screens/ProposalDetails"));
const DeveloperVerification = React.lazy(
  () => import("screens/DeveloperVerification")
);
const OfferDetails = React.lazy(() => import("screens/OfferDetails"));
const SendProposal = React.lazy(() => import("screens/SendProposal"));
const NewMonitoredProject = React.lazy(
  () => import("screens/NewMonitoredProject")
);
const SentProposalDetails = React.lazy(
  () => import("screens/SentProposalDetails")
);
const MonitoredProjectDetails = React.lazy(
  () => import("screens/MonitoredProjectDetails")
);
const MembersList = React.lazy(() => import("screens/MembersList"));
const Visitor = React.lazy(() => import("screens/Visitor"));
const PropertyDevelopers = React.lazy(
  () => import("screens/admin/PropertyDevelopers")
);
const PropertyDeveloperDetails = React.lazy(
  () => import("screens/admin/PropertyDeveloperDetails")
);
const PropertyOwnerDetails = React.lazy(
  () => import("screens/admin/PropertyOwnerDetails")
);
const PropertyOwners = React.lazy(() => import("screens/admin/PropertyOwners"));
const AdminMonitoredProjectDetails = React.lazy(
  () => import("screens/admin/MonitoredProjectDetails")
);
const AdminTrackedProjectDetails = React.lazy(
  () => import("screens/admin/TrackedProjectDetails")
);
const AdminListedProjectDetails = React.lazy(
  () => import("screens/admin/ListedProjectsDetails")
);
const AdminProjectProposalDetails = React.lazy(
  () => import("screens/admin/ProposalDetails")
);
const ListedProjects = React.lazy(() => import("screens/admin/ListedProjects"));
const MonitoredProjects = React.lazy(
  () => import("screens/admin/MonitoredProjects")
);
const TrackedProjects = React.lazy(
  () => import("screens/admin/TrackedProjects")
);
const AdminMonitoredProjectMemberList = React.lazy(
  () => import("screens/admin/MembersList")
);
const NotFound = () => {
  return (
    <div className="w-[100%] text-black text-[32px] h-[100%] overflow-hidden flex items-center justify-center ">
      <p> Page Not Found</p>
    </div>
  );
};

const Routers = () => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center mt-[350px] z-50">
          <LoadingIcon className="animate-pulse  w-[80px] h-[80px] " />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/forgot-password" element={<ForogotPassword />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />
        <Route
          path="/offers"
          element={
            <PrivateRoute>
              <Offers />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/projects/list/details/:projectId"
          element={
            <PrivateRoute>
              <ProjectDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/track/details/:projectId"
          element={
            <PrivateRoute>
              <TrackProjectDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/list/details/:projectId/proposal/:proposalId"
          element={
            <PrivateRoute>
              <ProposalDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/verify"
          element={
            <PrivateRoute>
              <DeveloperVerification />
            </PrivateRoute>
          }
        />
        <Route element={<NotFound />} />
        <Route
          path="/offers/:offersId"
          element={
            <PrivateRoute>
              <OfferDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/create-monitored-project"
          element={
            <PrivateRoute>
              <NewMonitoredProject />
            </PrivateRoute>
          }
        />
        <Route
          path="/offers/:offersId/send-proposal"
          element={
            <PrivateRoute>
              <SendProposal />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/sent-proposal/:sentProposalId/:projectId"
          element={
            <PrivateRoute>
              <SentProposalDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects/monitored-projects/:projectId"
          element={
            <PrivateRoute>
              <MonitoredProjectDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/projects/monitored-projects/:projectId/members"
          element={
            <PrivateRoute>
              <MembersList />
            </PrivateRoute>
          }
        />
        <Route
          path="/visitor/monitored-projects"
          element={
            <VisitorRouter>
              <Visitor />
            </VisitorRouter>
          }
        />
        <Route
          path="/property-developers"
          element={
            <AdminRouter>
              <PropertyDevelopers />
            </AdminRouter>
          }
        />
        <Route
          path="/property-developers/:developerId"
          element={
            <AdminRouter>
              <PropertyDeveloperDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/property-owners"
          element={
            <AdminRouter>
              <PropertyOwners />
            </AdminRouter>
          }
        />
        <Route
          path="/property-owners/:ownerId"
          element={
            <AdminRouter>
              <PropertyOwnerDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/listed-projects"
          element={
            <AdminRouter>
              <ListedProjects />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/tracked-projects"
          element={
            <AdminRouter>
              <TrackedProjects />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/tracked-projects/:projectId"
          element={
            <AdminRouter>
              <AdminTrackedProjectDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/listed-projects/:projectId"
          element={
            <AdminRouter>
              <AdminListedProjectDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/listed-projects/:projectId/:proposalId"
          element={
            <AdminRouter>
              <AdminProjectProposalDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/monitored-projects"
          element={
            <AdminRouter>
              <MonitoredProjects />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/monitored-projects/:projectId"
          element={
            <AdminRouter>
              <AdminMonitoredProjectDetails />
            </AdminRouter>
          }
        />
        <Route
          path="/admin/monitored-projects/:projectId/members"
          element={
            <AdminRouter>
              <AdminMonitoredProjectMemberList />
            </AdminRouter>
          }
        />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Suspense>
  );
};

export default Routers;
